import {
    bindPopover,
    bindTrigger,
    usePopupState,
} from "material-ui-popup-state/hooks";
import {
    Button, capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {useMutation, useQueryClient} from "react-query";
import {enqueueSnackbar} from "notistack";
import {useT} from "../../i18n";
import {useDeleteMandantFreedays} from "../../client/hooks";

export default function DeleteFreeDaysButton({mandantId,id}: { mandantId: string,id: string }) {
    const mutate = useLoeschenFreiezeit(mandantId,id);
    const {t: translation} = useT("freedays");
    const popupState = usePopupState({
        variant: "popover",
        popupId: `freeday-${id}-delete`,
    });
    return (
        <>
            <IconButton {...bindTrigger(popupState)} aria-label="delete">
                <DeleteIcon/>
            </IconButton>
            <Dialog {...bindPopover(popupState)}>
                <DialogTitle id="alert-dialog-title">
                    {capitalize(translation("delete-form-title"))}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {capitalize(translation("delete-form-description"))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => popupState.close()} color="inherit">
                        {capitalize(translation("common:cancel"))}
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            mutate.mutate();
                            popupState.close();
                        }}
                    >
                        {capitalize(translation("common:delete"))}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

function useLoeschenFreiezeit(mandantId:string, id: string) {
    const deleteFreeDay = useDeleteMandantFreedays()
    const queryClient = useQueryClient();
    const {t: translation} = useT("freedays");

    return useMutation(
        () => {
            return deleteFreeDay(mandantId,id);
        },
        {
            onSuccess: async () => {
                await queryClient.invalidateQueries(["freedays"]);
                enqueueSnackbar(capitalize(translation("freedays-delete-success")), {variant: "success"});
            },
            onError: () => {
                enqueueSnackbar(capitalize(translation("freedays-delete-error")), {variant: "error"});
            },
        }
    );
}